module.exports = __webpack_public_path__ + "static/media/chanel-chance-big.ce372825.png";